(function () {
  'use strict';

  document.documentElement.classList.add('js');

  if (window.__SC_PRODUCT_COMMERCE__) return;
  window.__SC_PRODUCT_COMMERCE__ = true;

  const localizedRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setMessage(root, text, type) {
    if (!root) return;
    const node = root.querySelector('[data-product-message]');
    if (!node) return;
    node.textContent = text || '';
    node.classList.toggle('pdp__message--success', type === 'success');
    node.classList.toggle('pdp__message--error', type === 'error');
  }

  function parseProductData(root) {
    const node = root.querySelector('[data-product-variants]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('SneakClean: no se pudieron leer las variantes.', error);
      return null;
    }
  }

  function selectedOptions(form, optionCount) {
    const values = [];
    for (let index = 0; index < optionCount; index += 1) {
      const fieldset = form.querySelector(`[data-option-position="${index + 1}"]`);
      values.push(fieldset && fieldset.querySelector('[data-option-value]:checked')?.value || null);
    }
    return values;
  }

  function findExactVariant(variants, values) {
    if (!values.length || values.some((value) => value === null)) return null;
    return variants.find((variant) => variant.options.every((option, index) => option === values[index])) || null;
  }

  function updateOptionAvailability(form, variants, values) {
    form.querySelectorAll('[data-option-position]').forEach((fieldset) => {
      const position = Number(fieldset.dataset.optionPosition) - 1;
      fieldset.querySelectorAll('[data-option-value]').forEach((input) => {
        const possible = variants.some((variant) => variant.options.every((optionValue, index) => {
          if (index === position) return optionValue === input.value;
          return values[index] === null || optionValue === values[index];
        }));
        input.disabled = !possible;
        const label = form.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label) label.setAttribute('aria-disabled', possible ? 'false' : 'true');
      });
    });
  }

  // Galería deslizable: todas las fotos viven en una pista con scroll-snap.
  // Mostrar una foto = desplazar la pista hasta ella. El contador y las
  // miniaturas siguen a la foto visible, sea por flecha, miniatura o dedo.
  function gallerySlides(root) {
    return Array.from(root.querySelectorAll('[data-media-slide]'));
  }

  function markMedia(root, index) {
    const slides = gallerySlides(root);
    if (!slides.length) return;
    const current = slides[index];
    slides.forEach((slide, position) => {
      const active = position === index;
      slide.classList.toggle('is-current', active);
      if (!active) slide.querySelector('video')?.pause();
    });
    root.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
      const active = String(thumb.dataset.mediaId) === String(current?.dataset.mediaId);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    const counter = root.querySelector('[data-gallery-counter]');
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
  }

  function showMediaIndex(root, index, smooth) {
    const track = root.querySelector('[data-gallery-track]');
    const slides = gallerySlides(root);
    if (!track || !slides.length) return;
    const target = Math.max(0, Math.min(slides.length - 1, index));
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: slides[target].offsetLeft - track.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    markMedia(root, target);
  }

  function showMedia(root, mediaId, smooth) {
    if (!mediaId) return;
    const index = gallerySlides(root).findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
    if (index >= 0) showMediaIndex(root, index, smooth);
  }

  function currentMediaIndex(root) {
    return Math.max(0, gallerySlides(root).findIndex((slide) => slide.classList.contains('is-current')));
  }

  function initializeGallery(root) {
    const track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (index !== currentMediaIndex(root)) markMedia(root, index);
      });
    }, { passive: true });

    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showMediaIndex(root, currentMediaIndex(root) - 1, true));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showMediaIndex(root, currentMediaIndex(root) + 1, true));
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showMediaIndex(root, currentMediaIndex(root) - 1, true); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showMediaIndex(root, currentMediaIndex(root) + 1, true); }
    });

    const dialog = root.querySelector('[data-gallery-dialog]');
    const dialogImage = root.querySelector('[data-gallery-dialog-img]');
    root.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
      const image = gallerySlides(root)[currentMediaIndex(root)]?.querySelector('img');
      if (!dialog || !dialogImage || !image) return;
      // La versión más grande del srcset; Shopify la entrega a 1400 px.
      const sources = (image.getAttribute('srcset') || '').split(',').map((part) => part.trim().split(' ')[0]).filter(Boolean);
      dialogImage.src = sources[sources.length - 1] || image.currentSrc || image.src;
      dialogImage.alt = image.alt || '';
      if (typeof dialog.showModal === 'function') dialog.showModal();
    });
    root.querySelector('[data-gallery-dialog-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    // Posición inicial sin animación: la foto de la variante elegida.
    const initial = gallerySlides(root).findIndex((slide) => slide.classList.contains('is-current'));
    if (initial > 0) window.requestAnimationFrame(() => showMediaIndex(root, initial, false));
  }

  // Costo por par = precio ÷ pares, en pesos enteros hacia arriba. La misma
  // regla que el Liquid (main-product y pdp-contenido). Sin pares, se oculta.
  function costPerPair(variant) {
    const pairs = Number(variant && variant.yieldPairs);
    if (!variant || !Number.isFinite(pairs) || pairs <= 0) return null;
    return { pairs, cost: Math.ceil(variant.price / 100 / pairs) };
  }

  function renderYield(root, variant) {
    const info = costPerPair(variant);
    const text = info ? `≈ $${info.cost.toLocaleString('es-CL')}` : '';
    const line = root.querySelector('[data-yield]');
    if (line) {
      line.classList.toggle('is-hidden', !info);
      if (info) {
        line.querySelector('[data-yield-pairs]').textContent = info.pairs.toLocaleString('es-CL');
        line.querySelector('[data-yield-cost]').textContent = text;
      }
    }
    // El comparador vive en otra sección (pdp-contenido): se busca en la página.
    const section = document.querySelector('[data-yield-section]');
    if (section && info) {
      const pairs = section.querySelector('[data-yield-pairs]');
      const cost = section.querySelector('[data-yield-cost]');
      if (pairs) pairs.textContent = info.pairs.toLocaleString('es-CL');
      if (cost) cost.textContent = text;
    }
    document.querySelectorAll('[data-yield-row]').forEach((row) => {
      const active = variant && String(row.dataset.variantId) === String(variant.id);
      row.classList.toggle('is-active', Boolean(active));
      row.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function renderPrice(root, variant) {
    const wrapper = root.querySelector('[data-product-price]');
    if (!wrapper || !variant) return;

    const price = document.createElement('span');
    price.className = 'price';
    price.dataset.priceWrapper = '';

    if (variant.compareAtPrice > variant.price) {
      const compare = document.createElement('del');
      compare.className = 'price__compare';
      compare.dataset.priceCompare = '';
      compare.textContent = variant.compareAtPriceFormatted;
      compare.setAttribute('aria-label', `Precio anterior ${variant.compareAtPriceFormatted}`);
      price.append(compare);
    }

    const current = document.createElement('span');
    current.className = 'price__current';
    current.dataset.priceCurrent = '';
    current.textContent = variant.priceFormatted;
    current.setAttribute('aria-label', `Precio actual ${variant.priceFormatted}`);
    price.append(current);
    wrapper.replaceChildren(price);

    const discount = root.querySelector('[data-product-discount]');
    if (discount) {
      // El texto viene armado desde snippets/price.liquid (savingsLabel), la
      // misma fuente que las tarjetas: acá no se vuelve a calcular el ahorro.
      const label = variant.savingsLabel || '';
      discount.textContent = label;
      discount.classList.toggle('is-hidden', label === '');
    }

    renderCuotas(root, variant);
    renderClub(root, variant);
  }

  // Formato chileno: separador de miles con punto. El precio viene en centavos.
  function pesos(centavos) {
    return '$' + Math.round(centavos / 100).toLocaleString('es-CL');
  }

  // Cuotas: se recalculan con la variante elegida y desaparecen bajo el mínimo.
  // Sin esto, cambiar de 250 a 500 ml dejaba una cuota que ya no correspondía.
  function renderCuotas(root, variant) {
    const el = root.querySelector('[data-product-cuotas]');
    if (!el) return;
    const n = Number(el.dataset.cuotas || 0);
    const min = Number(el.dataset.cuotasMin || 0);
    const aplica = n > 1 && variant.price >= min;
    const titulo = el.querySelector('[data-cuotas-titulo]');
    const bajada = el.querySelector('[data-cuotas-bajada]');
    // El texto de medios de pago viene del Liquid (settings.cuotas_detalle);
    // se guarda la primera vez para no perderlo al reescribir la bajada.
    if (bajada && el.dataset.pagoDetalle === undefined) {
      el.dataset.pagoDetalle = bajada.textContent.replace(/^de \$[\d.]+ · /, '').trim();
    }
    if (titulo) titulo.textContent = aplica ? `${n} cuotas sin interés` : 'Paga como prefieras';
    if (bajada) bajada.textContent = (aplica ? `de ${pesos(variant.price / n)} · ` : '') + (el.dataset.pagoDetalle || '');
  }

  // Puntos del Club: precio ÷ CLP por punto. El valor viene del ajuste del tema
  // y debe calzar con loyalty_config.clp_por_punto en Jack.
  function renderClub(root, variant) {
    const el = root.querySelector('[data-product-club]');
    if (!el) return;
    const clp = Number(el.dataset.clpPunto || 0);
    const puntos = clp > 0 ? Math.floor(variant.price / 100 / clp) : 0;
    const titulo = el.querySelector('[data-club-titulo]');
    if (titulo) titulo.textContent = puntos >= 1 ? `Suma ${puntos.toLocaleString('es-CL')} puntos` : '';
    el.classList.toggle('is-hidden', puntos < 1);
  }

  function renderPriceRange(root, formattedPrice) {
    const wrapper = root.querySelector('[data-product-price]');
    if (!wrapper || !formattedPrice) return;
    const price = document.createElement('span');
    price.className = 'price price--from';
    price.dataset.priceWrapper = '';
    const prefix = document.createElement('span');
    prefix.className = 'price__from';
    prefix.textContent = 'Desde ';
    const current = document.createElement('span');
    current.className = 'price__current';
    current.dataset.priceCurrent = '';
    current.textContent = formattedPrice;
    current.setAttribute('aria-label', `Precio desde ${formattedPrice}`);
    price.append(prefix, current);
    wrapper.replaceChildren(price);
  }

  function serviceDays(variant) {
    const min = Number(variant.serviceDaysMin);
    const max = Number(variant.serviceDaysMax);
    if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max <= 0) return '';
    return `${min === max ? min : `${min}–${max}`} días corridos`;
  }

  function renderVariant(root, form, data, variant, complete) {
    const idInput = form.querySelector('[data-variant-id]');
    const submit = form.querySelector('[data-product-submit]');
    const stickySubmit = root.querySelector('[data-sticky-submit]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stock = form.querySelector('[data-variant-stock]');
    const sku = form.querySelector('[data-variant-sku]');
    const service = form.querySelector('[data-variant-service]');
    const shipping = root.querySelector('[data-product-shipping]');
    const quantity = form.querySelector('[data-product-quantity]');

    if (!variant || !complete) {
      if (idInput) {
        idInput.value = '';
        idInput.disabled = true;
      }
      if (submit) submit.disabled = true;
      if (stickySubmit) stickySubmit.disabled = true;
      const label = submit?.querySelector('[data-submit-label]');
      if (label) label.textContent = complete ? 'Combinación no disponible' : 'Selecciona una opción';
      if (stickySubmit) stickySubmit.textContent = complete ? 'No disponible' : 'Selecciona';
      if (stock) stock.textContent = complete ? 'Combinación no disponible' : 'Selecciona una opción';
      if (stickyPrice) stickyPrice.textContent = data.priceMinFormatted ? `Desde ${data.priceMinFormatted}` : '';
      renderPriceRange(root, data.priceMinFormatted);
      sku?.classList.add('is-hidden');
      service?.classList.add('is-hidden');
      if (shipping) {
        const showShipping = data.purchaseFlow === 'standard' && Boolean(data.allVariantsRequireShipping) && Boolean(data.shippingMessage);
        shipping.classList.toggle('is-hidden', !showShipping);
      }
      const discount = root.querySelector('[data-product-discount]');
      if (discount) {
        discount.textContent = '';
        discount.classList.add('is-hidden');
      }
      renderYield(root, null);
      return;
    }

    if (idInput) {
      idInput.value = variant.id;
      idInput.disabled = false;
    }

    const available = Boolean(variant.available);
    if (submit) submit.disabled = !available;
    if (stickySubmit) stickySubmit.disabled = !available;
    const label = submit?.querySelector('[data-submit-label]');
    if (label) label.textContent = available ? (submit.dataset.addLabel || 'Agregar al carrito') : 'Agotado';
    if (stickySubmit) stickySubmit.textContent = available ? 'Agregar' : 'Agotado';
    if (stock) {
      const managed = Boolean(variant.inventoryManagement);
      const lowStock = managed && variant.inventoryPolicy !== 'continue' && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= 5;
      stock.textContent = available
        ? (lowStock ? `Últimas ${variant.inventoryQuantity} unidades` : 'Disponible')
        : 'Agotado';
    }
    if (stickyPrice) stickyPrice.textContent = variant.priceFormatted;
    const stickyVariant = root.querySelector('[data-sticky-variant]');
    if (stickyVariant) stickyVariant.textContent = data.hasOnlyDefaultVariant ? '' : (variant.title || '');

    if (quantity) {
      const minimum = Math.max(1, Number(variant.quantityMin) || 1);
      const increment = Math.max(1, Number(variant.quantityIncrement) || 1);
      const maximum = Number(variant.quantityMax) || 0;
      quantity.min = String(minimum);
      quantity.step = String(increment);
      if (maximum > 0) quantity.max = String(maximum);
      else quantity.removeAttribute('max');
      const requested = Math.max(minimum, Number(quantity.value) || minimum);
      quantity.value = String(maximum > 0 ? Math.min(requested, maximum) : requested);
    }

    if (sku) {
      sku.classList.toggle('is-hidden', !variant.sku);
      const value = sku.querySelector('span');
      if (value) value.textContent = variant.sku || '';
    }

    if (service) {
      const pairs = service.querySelector('[data-service-pairs]');
      const speed = service.querySelector('[data-service-speed]');
      const days = service.querySelector('[data-service-days]');
      if (pairs) pairs.textContent = variant.servicePairs ? `${variant.servicePairs} ${Number(variant.servicePairs) === 1 ? 'par' : 'pares'}` : '';
      if (speed) speed.textContent = variant.serviceSpeed ? ` · ${String(variant.serviceSpeed).charAt(0).toUpperCase()}${String(variant.serviceSpeed).slice(1)}` : '';
      if (days) days.textContent = serviceDays(variant) ? ` · ${serviceDays(variant)}` : '';
      service.classList.toggle('is-hidden', !variant.servicePairs && !variant.serviceSpeed && !serviceDays(variant));
    }

    if (shipping) {
      const showShipping = data.purchaseFlow === 'standard' && Boolean(variant.requiresShipping) && Boolean(data.shippingMessage);
      shipping.classList.toggle('is-hidden', !showShipping);
    }

    renderPrice(root, variant);
    renderYield(root, variant);
    if (root.dataset.productReady === 'true') showMedia(root, variant.featuredMediaId || data.defaultMediaId, true);
    setMessage(root, '', null);

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url);
    } catch (error) {
      // La selección sigue funcionando aunque history no esté disponible.
    }
  }

  // La barra fija aparece cuando el botón principal sale de la pantalla, en
  // celular y en escritorio. Mientras el botón está a la vista sería un
  // segundo botón encima del primero.
  function initializeSticky(root) {
    const sticky = root.querySelector('[data-sticky-atc]');
    const cta = root.querySelector('[data-product-submit]');
    if (!sticky || !cta || !('IntersectionObserver' in window)) {
      sticky?.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
      document.documentElement.classList.toggle('has-sticky-atc', past);
    });
    observer.observe(cta);
  }

  // La barra de secciones solo muestra anclas que existen en la página.
  function pruneSubnav(root) {
    const nav = root.querySelector('[data-pdp-subnav]');
    if (!nav) return;
    const prune = () => {
      nav.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.hidden = !document.getElementById(link.getAttribute('href').slice(1));
      });
      nav.hidden = !nav.querySelector('a:not([hidden])');
    };
    prune();
    // Loox monta #looxReviews después de cargar.
    window.setTimeout(prune, 2500);
  }

  function initializeProduct(root) {
    if (root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';

    const data = parseProductData(root);
    const form = root.querySelector('[data-product-form]');
    if (!data || !form) return;

    const idInput = form.querySelector('[data-variant-id]');
    if (idInput && idInput.value) idInput.disabled = false;
    const quantity = form.querySelector('[data-product-quantity]');
    if (quantity) quantity.disabled = false;

    function sync() {
      if (data.hasOnlyDefaultVariant) {
        const defaultVariant = data.variants.find((variant) => String(variant.id) === String(data.initialVariantId)) || data.variants[0] || null;
        renderVariant(root, form, data, defaultVariant, Boolean(defaultVariant));
        return;
      }

      const values = selectedOptions(form, data.options.length);
      updateOptionAvailability(form, data.variants, values);

      form.querySelectorAll('[data-option-position]').forEach((fieldset, index) => {
        const selected = values[index];
        const label = fieldset.querySelector('[data-selected-option]');
        if (label) label.textContent = selected || 'Sin seleccionar';
        fieldset.querySelectorAll('[data-option-value]').forEach((input) => {
          const swatch = form.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          swatch?.classList.toggle('is-active', input.checked);
        });
      });

      const complete = values.every((value) => value !== null);
      renderVariant(root, form, data, findExactVariant(data.variants, values), complete);
    }

    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-value]')) sync();
    });

    form.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach((button) => {
      button.addEventListener('click', (event) => {
        // application.js también tuvo un stepper global; detenemos la
        // propagación para que este formulario cambie una sola unidad.
        event.preventDefault();
        event.stopPropagation();
        const input = button.closest('[data-qty-wrap]')?.querySelector('input[name="quantity"]');
        if (!input) return;
        const min = Math.max(1, Number(input.min) || 1);
        const step = Math.max(1, Number(input.step) || 1);
        const max = Number(input.max) || Number.POSITIVE_INFINITY;
        const current = Math.max(min, Number(input.value) || min);
        input.value = String(button.matches('[data-qty-minus]')
          ? Math.max(min, current - step)
          : Math.min(max, current + step));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    root.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(root, thumb.dataset.mediaId, true));
    });

    initializeGallery(root);

    // Las barras del comparador eligen el formato en ESTE formulario: una sola
    // selección en toda la página (la referencia tenía la barra fija y el
    // título mostrando formatos distintos; acá no puede pasar).
    document.querySelectorAll('[data-yield-row]').forEach((row) => {
      row.addEventListener('click', () => {
        if (row.getAttribute('aria-disabled') === 'true') return;
        const input = Array.from(form.querySelectorAll('[data-option-position="1"] [data-option-value]'))
          .find((candidate) => candidate.value === row.dataset.optionValue);
        if (!input || input.disabled) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    initializeSticky(root);
    pruneSubnav(root);

    sync();
    root.dataset.productReady = 'true';
  }

  async function submitProductForm(event) {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const root = form.closest('[data-product-section]');
    const idInput = form.querySelector('[data-variant-id]');
    const submit = form.querySelector('[data-product-submit]');
    const stickySubmit = root?.querySelector('[data-sticky-submit]');
    const label = submit?.querySelector('[data-submit-label]');

    if (!idInput || idInput.disabled || !idInput.value || submit?.disabled) {
      setMessage(root, 'Selecciona una opción disponible antes de agregar.', 'error');
      return;
    }

    const originalLabel = label?.textContent || 'Agregar al carrito';
    if (submit) submit.disabled = true;
    if (stickySubmit) stickySubmit.disabled = true;
    if (label) label.textContent = 'Agregando…';
    if (stickySubmit) stickySubmit.textContent = 'Agregando…';
    setMessage(root, 'Agregando al carrito…', null);

    try {
      const formData = new FormData(form);
      const cartSectionId = document.querySelector('[data-sc-cart-root]')?.dataset.sectionId;
      if (cartSectionId) formData.append('sections', cartSectionId);
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(`${localizedRoot()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
        credentials: 'same-origin'
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || 'No pudimos agregar el producto.');

      setMessage(root, 'Agregado al carrito.', 'success');
      document.dispatchEvent(new CustomEvent('sneakclean:cart-added', {
        bubbles: true,
        detail: { item: payload, source: 'product-page' }
      }));
    } catch (error) {
      setMessage(root, error.message || 'No pudimos agregar el producto. Intenta nuevamente.', 'error');
    } finally {
      const selectedVariant = idInput.value;
      const data = parseProductData(root);
      const variant = data?.variants.find((candidate) => String(candidate.id) === String(selectedVariant));
      const available = Boolean(variant?.available);
      if (submit) submit.disabled = !available;
      if (stickySubmit) stickySubmit.disabled = !available;
      if (label) label.textContent = available ? originalLabel : 'Agotado';
      if (stickySubmit) stickySubmit.textContent = available ? 'Agregar' : 'Agotado';
    }
  }

  // Capture deja este formulario bajo un único dueño y evita POST duplicados
  // si otra app agrega listeners delegados al formulario.
  document.addEventListener('submit', submitProductForm, true);

  function initializeTabs(container) {
    if (container.dataset.tabsAccessible === 'true') return;
    container.dataset.tabsAccessible = 'true';
    const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
    const panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

    function activate(tab, focus) {
      tabs.forEach((candidate) => {
        const active = candidate === tab;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-selected', active ? 'true' : 'false');
        candidate.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        // Neutraliza el `style.display` que todavía puede dejar el bloque de
        // pestañas legado de application.js hasta que se retire.
        panel.style.removeProperty('display');
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
      if (focus) tab.focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let target = index;
        if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        activate(tabs[target], true);
      });
    });
  }

  let lastFilterTrigger = null;

  const mobileFilters = window.matchMedia('(max-width: 900px)');

  function configureFilterAccessibility(section) {
    const drawer = section.querySelector('[data-filter-drawer]');
    const trigger = section.querySelector('[data-filter-open]');
    if (!drawer) return;
    const open = drawer.classList.contains('is-open');
    drawer.setAttribute('aria-hidden', mobileFilters.matches && !open ? 'true' : 'false');
    trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (mobileFilters.matches) {
      drawer.setAttribute('role', 'dialog');
      if (open) drawer.setAttribute('aria-modal', 'true');
      else drawer.removeAttribute('aria-modal');
    } else {
      drawer.removeAttribute('role');
      drawer.removeAttribute('aria-modal');
    }
    if (!mobileFilters.matches && open) {
      drawer.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('is-locked');
    }
  }

  function openFilters(section, trigger) {
    const drawer = section.querySelector('[data-filter-drawer]');
    if (!drawer) return;
    lastFilterTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    trigger?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('is-locked');
    window.requestAnimationFrame(() => {
      drawer.querySelector('[data-filter-close], input, button')?.focus({ preventScroll: true });
    });
  }

  function closeFilters(section) {
    const drawer = section.querySelector('[data-filter-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', mobileFilters.matches ? 'true' : 'false');
    drawer.removeAttribute('aria-modal');
    section.querySelector('[data-filter-open]')?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('is-locked');
    lastFilterTrigger?.focus();
  }

  function cleanFormUrl(form) {
    const url = new URL(form.action, window.location.origin);
    new FormData(form).forEach((value, key) => {
      if (String(value).trim() !== '') url.searchParams.append(key, value);
    });
    return url;
  }

  async function replaceCatalog(section, url, pushHistory) {
    const status = section.querySelector('[data-catalog-status]');
    section.classList.add('is-loading');
    section.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Actualizando productos…';

    try {
      const requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('section_id', section.dataset.sectionId);
      const response = await fetch(requestUrl, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('No pudimos actualizar los productos.');
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-product-catalog]');
      if (!fresh) throw new Error('Shopify no devolvió la sección de catálogo.');

      section.replaceWith(fresh);
      configureFilterAccessibility(fresh);
      if (pushHistory) {
        const cleanUrl = new URL(url, window.location.origin);
        cleanUrl.searchParams.delete('section_id');
        window.history.pushState({ catalog: true }, '', cleanUrl);
      }
      fresh.querySelector('[data-catalog-status]')?.replaceChildren(document.createTextNode('Productos actualizados.'));
    } catch (error) {
      section.classList.remove('is-loading');
      section.removeAttribute('aria-busy');
      if (status) status.textContent = error.message || 'No pudimos actualizar los productos.';
    }
  }

  async function loadMore(section, link) {
    const status = section.querySelector('[data-catalog-status]');
    const button = link;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Cargando…';
    if (status) status.textContent = 'Cargando más productos…';

    try {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('section_id', section.dataset.sectionId);
      const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('No pudimos cargar más productos.');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshGrid = parsed.querySelector('[data-catalog-grid]');
      const currentGrid = section.querySelector('[data-catalog-grid]');
      if (!freshGrid || !currentGrid) throw new Error('Shopify no devolvió más productos.');

      Array.from(freshGrid.children).forEach((card) => currentGrid.append(card));
      const currentLoadMore = section.querySelector('[data-load-more-wrap]');
      const freshLoadMore = parsed.querySelector('[data-load-more-wrap]');
      if (currentLoadMore) {
        if (freshLoadMore) currentLoadMore.replaceWith(freshLoadMore);
        else currentLoadMore.remove();
      }
      url.searchParams.delete('section_id');
      window.history.replaceState({ catalog: true }, '', url);
      if (status) status.textContent = 'Más productos cargados.';
    } catch (error) {
      button.removeAttribute('aria-disabled');
      button.textContent = 'Cargar más';
      if (status) status.textContent = error.message || 'No pudimos cargar más productos.';
    }
  }

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-filter-open]');
    if (open) {
      const section = open.closest('[data-product-catalog]');
      if (section) {
        event.preventDefault();
        openFilters(section, open);
      }
      return;
    }

    const close = event.target.closest('[data-filter-close]');
    if (close) {
      const section = close.closest('[data-product-catalog]');
      if (section) {
        event.preventDefault();
        closeFilters(section);
      }
      return;
    }

    const catalogLink = event.target.closest('[data-catalog-link]');
    if (catalogLink) {
      const section = catalogLink.closest('[data-product-catalog]');
      if (section) {
        event.preventDefault();
        replaceCatalog(section, catalogLink.href, true);
      }
      return;
    }

    const more = event.target.closest('[data-load-more]');
    if (more && more.getAttribute('aria-disabled') !== 'true') {
      const section = more.closest('[data-product-catalog]');
      if (section) {
        event.preventDefault();
        loadMore(section, more);
      }
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-catalog-form]');
    if (!form) return;
    const section = form.closest('[data-product-catalog]');
    if (!section) return;
    event.preventDefault();
    closeFilters(section);
    replaceCatalog(section, cleanFormUrl(form), true);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-catalog-sort]')) return;
    event.target.closest('[data-catalog-form]')?.requestSubmit();
  });

  document.addEventListener('keydown', (event) => {
    const section = document.querySelector('[data-product-catalog]');
    const drawer = section?.querySelector('[data-filter-drawer].is-open');
    if (!drawer) return;
    if (event.key === 'Escape') {
      closeFilters(section);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'))
      .filter((node) => node.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('popstate', () => {
    const section = document.querySelector('[data-product-catalog]');
    if (section) replaceCatalog(section, window.location.href, false);
  });

  async function initializeRecommendations(section) {
    if (section.dataset.recommendationsLoaded === 'true' || !section.dataset.recommendationsUrl) return;
    section.dataset.recommendationsLoaded = 'true';
    try {
      const url = new URL(section.dataset.recommendationsUrl, window.location.origin);
      url.searchParams.set('section_id', section.dataset.sectionId);
      url.searchParams.set('product_id', section.dataset.productId);
      url.searchParams.set('limit', section.dataset.limit || '4');
      url.searchParams.set('intent', section.dataset.intent || 'related');
      const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('recommendations request failed');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = parsed.querySelector('[data-product-recommendations]');
      if (!fresh) throw new Error('recommendations section missing');
      fresh.dataset.recommendationsLoaded = 'true';
      section.replaceWith(fresh);
    } catch (error) {
      // El fallback Liquid permanece visible si Shopify Recommendations falla.
      console.warn('SneakClean: no se pudieron actualizar las recomendaciones.', error);
    }
  }

  function initialize() {
    document.querySelectorAll('[data-product-section]').forEach(initializeProduct);
    document.querySelectorAll('[data-tabs]').forEach(initializeTabs);
    document.querySelectorAll('[data-product-catalog]').forEach(configureFilterAccessibility);
    document.querySelectorAll('[data-product-recommendations]').forEach(initializeRecommendations);
  }

  if (typeof mobileFilters.addEventListener === 'function') {
    mobileFilters.addEventListener('change', () => {
      document.querySelectorAll('[data-product-catalog]').forEach(configureFilterAccessibility);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();

  document.addEventListener('shopify:section:load', initialize);
}());
